const Inc = {
	FUEL: 100,
	PARAM_NAMES:["種族","出身地","目の色","所持品"],
	FIGURES:["cat","dog","horse","crow","frog"],
	LV:["初級","中級","上級"],
	LV_FIGURES:["baby-carriage","hat-wizard","dragon"],
	TYPE_NAMES:[
		["キティ・パティ","ドッゴ","ワイルドホース","カー","フロッガ"],
		["アラベック自治区","ナガサキ管区","リャンタ市","テールルー保護区","ギギドド街"],
		["ヘーゼル","グレー","ハシバミ","エメラルド","トパーズ"],
		["測量機","３Ｄコピー","電子辞書","スピーカー","エンジンＫ"],
	],
	NEWS_TEXT1: [
		[
			"[NAME]が子供をさらってるって噂があるもんだから[NAME]禁止令発令！",
			"[NAME]禁止令が出た！夜の公園に[NAME]が集まってて怖いってさ！",
			"暴行事件が起きて犯人は[NAME]だって誰かが言ったもんだから[NAME]禁止令が出ちゃったねえ。",
			"いきなり[NAME]禁止令だってさ。[NAME]が目障りだって奴がいるんだろうね。",
			"[NAME]禁止令が出たよ。一応軍部に[NAME]のスパイがいるとかなんとか。うさんくさいな。"
		],
		[
			"[NAME]禁止令が出た。[NAME]に対する警戒が強まってるのを感じるわー。",
			"こんな時に[NAME]の若手がデモをしたって！馬鹿じゃないの？で、[NAME]禁止令。",
			"労働組合が[NAME]の排除を提案した途端に[NAME]禁止令だって。単純！",
			"[NAME]の評判が悪い。すごく悪い。なんで悪いのかは知らん。誰も。[NAME]禁止令だよ。",
			"不景気が[NAME]のせいだって偉い誰かがテレビで言ったみたいね。そう、そういうプロパガンダで[NAME]禁止令。"
		],
		[
			"[NAME]禁止令が出たね。救世主の瞳が[NAME]だって…私が言ったんじゃないよ、うさんくさい預言者がさ。",
			"[NAME]の瞳をしたスパイが官邸から逃亡したって噂が噂を呼んで[NAME]禁止令だ！",
			"ホラ来た[NAME]禁止令だ。とにかく[NAME]の眼が嫌いって奴がいるみたい。",
			"はいはい[NAME]禁止令が来ましたよ。目が[NAME]色だとろくな大人にならないってジジイが言ったんだね。",
			"[NAME]禁止令が出たよ。なんでかしんないけど！とにかく！"
		],
		[
			"やばいよ、計画の一部が漏洩したっぽいね。[NAME]禁止令が出てるから注意して…",
			"[NAME]禁止令が出たよ。名目は密輸組織の摘発を目的だって話だけどどうかな…",
			"[NAME]を持った不審者が…つまり馬鹿がなんかしたのね、きっと。[NAME]禁止令だよ。",
			"[NAME]を装った爆弾によるテロが発生したってニュースになってる。ホントかどうか怪しいけど[NAME]禁止令が出てるから気を付けて。",
			"[NAME]の取扱業者に脱税の疑いだって。[NAME]禁止令に要注意…"
		],
	],
	NEWS_TEXT2: [
		[
			"噂が沈静化したみたい。[NAME]禁止令はナシになったよ。",
			"調査しても何も出てこなかったみたいね。当然！[NAME]禁止令は撤回。",
			"犯人はそのへんのチンピラだったってオチで[NAME]禁止令は撤回ですー。",
			"特に理由もなく[NAME]禁止令は撤回。はいはい。",
			"スパイが逮捕されて[NAME]禁止令は撤回！手際よすぎない？"
		],
		[
			"何らかの取引があったようでー、よくは知んないけどー、[NAME]禁止令撤回ー",
			"デモはあっさり鎮圧！よわっ！で、[NAME]禁止令は撤回されたよ。",
			"労働組合が方針を変更したとかいう話で[NAME]禁止令は撤回。反対が多かったのかな。",
			"[NAME]禁止令が撤回されたよ。禁止するより無視したいんだろうな。",
			"[NAME]禁止令は撤回だって。プロパガンダが逆効果だって気づいたみたい。えらいわー。"
		],
		[
			"デマの発信者が国外に逃亡したため[NAME]禁止令は撤回…とのこと！",
			"スパイの噂が否定されたので[NAME]禁止令は撤回…って誰が否定したの？怪しいわー。",
			"有志の働きかけで[NAME]禁止令は撤回でございます。",
			"総統の愛人の目が[NAME]だったから[NAME]禁止令は撤回。そんなことあるのねえ。",
			"なにか不都合があったんだろうね。しんないけど。[NAME]禁止令は撤回。"
		],
		[
			"漏洩した計画はデタラメだったみたい。誰かがうまいことやったね。[NAME]禁止令は撤回でえす。",
			"密輸組織に活動の実態がなかったってことで[NAME]禁止令は撤回だ！",
			"[NAME]の不足に不満の声が高まったもんで[NAME]禁止令は撤回。当然！",
			"[NAME]禁止令は撤回。規制緩和の呼びかけがどこからか出たみたいね。",
			"脱税疑惑がうやむやになって[NAME]禁止令は撤回。いい気味だ。"
		],
	],
	PROMPTS: {
		0: ["よろしくたのんます","ただいま戻りました","マジかー","行ってくるです","うへえ"],
		1: ["やる気だけはありますから","やる気で何とかしましたから","やる気はあるのに","やるぞやるぞ","やる気はあったのにさー"],
		2: ["急いでくれ、時間を無駄にしたくない","さあ、これでどうだ","とんだ無駄足だ","当然だ","こんなことになるとは…"],
		3: ["こんな感じです～","直してきました～","あ～","それではちょっくら～","あっはっは～"],
		4: ["どうっすか","今度こそどうっすか","だめっすか","ラジャー","やられたっす"],
		5: ["きっとお役に立てるかと","そろそろ私の出番でしょう","それは残念","行ってきましょう","足を引っ張りたくなかった…"],
		6: ["お任せ下さい","生まれ変わった僕を見て","承知！","いざジャバルー市！","ひええええ"],
		7: ["許可を！","これでどうだ","なんと","当然だ","無念…"],
		8: ["それでは見てもらいましょうかね","こんなんなりましたけど～","なるほどなるほど","ではでは","運の尽き"],
		9: ["行けますかね、私","もう一度お願いします","諦めません","私、頑張ります","いつもこうなの私"],
		10: ["よお、俺だよ","また俺だよ","ふん","だろ？","しっかりしてくれよ"],
		11: ["[NAME]だ、よろしく頼む","[NAME]だ、また来たぜ","分かった、出直す","おう、期待してくれ","あんたのせいじゃない"],
		12: ["こんにちは！","またこんにちは！","そっか、また来る","良かった、行ってくるね","がっかり"],
		13: ["まだ間に合いますか？","[NAME]です、今度こそ","そうですか、そうですか","行ってきます！","ははは…"],
		14: ["どーん！","だーん！","がーん！","ばーん！","ずどーん！"],
		15: ["さあ先生見ておくれ","先生よろしく","仕方ないね","一花咲かせましょ","散り時ね"],
		16: ["私、[NAME]","[NAME]が帰ってきたよ","ふうん","勝ったも同然","負けた…"],
		17: ["お邪魔しますよ","よろしいかな","ふむ、分かりました","では革命後にまた","次の世代に望みを…"],
		18: ["首都に革命の歌を！","我に光を！","貴様…！","貴様の期待を携えて行こう！","こんなはずでは…"],
		19: ["緊張するなあ","はあい、また僕です","あららら","気を引き締めて","え？なんで？僕が？"],
	},
	RANKS: ["F","F+","E-","E","E+","D-","D","D+","C-","C","C+","B-","B","B+","A-","A","A+","S-","S","S+","SS-","SS"],
	RANK_NAMES: ["物笑い","水すまし","根なし草","カナブン","野良犬","ハサミ","お荷物","福笑い","料理人","子猫","アイドル","炎壁","裏街道","真心シスターズ","電気","大工","番犬","怪獣","宝石","肖像","奇跡","聖母"],
}

export default Inc;